import { css } from "lit";
import { customElement } from "lit/decorators.js";
import { BasicButton } from "./BasicButton.js";

@customElement("alert-button")
export class AlertButton extends BasicButton {
	static readonly styles = [
		BasicButton.styles,
		css`
            button {
                background: var(--color-pink);
                color: black;
            }
            
            button:hover:not(:disabled) {
                background: #ff7f7f;
                box-shadow: 0 4px 15px rgba(255, 170, 170, 0.3);
                color: black;
            }
        `
	];
}

export default AlertButton;